import { APP_NAV_SIZES } from '@/lib/constants';

const commonTransition = { duration: 0.2, ease: 'easeInOut' };
const delayedTransition = { ...commonTransition, delay: 0.2 };

export const baseVariants = {
  open: (isSmallScreen: boolean) => ({
    width: !isSmallScreen ? APP_NAV_SIZES.open : APP_NAV_SIZES.openMobile,
  }),
  closed: { width: APP_NAV_SIZES.closed, transition: delayedTransition },
};

export const navItemVariants = {
  visible: {
    opacity: 1,
    x: 0,
    transition: { ...commonTransition, delay: 0.1 },
  },
  hidden: { opacity: 0, x: -2, transition: { ...commonTransition, duration: 0.15, delay: 0.2 } },
};

export const usageVariants = {
  visible: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: {
      ...commonTransition,
      duration: 0.3,
      opacity: delayedTransition,
    },
  },
  hidden: {
    opacity: 0,
    x: -10,
    scale: 0.96,
    transition: {
      ...commonTransition,
      delay: 0,
    },
  },
};

export const iconVariants = {
  visible: {
    opacity: 1,
    transition: { duration: 0, delay: 0, ease: 'linear' },
  },
  hidden: { opacity: 0, transition: { ...commonTransition, ease: 'linear', delay: 0.4 } },
};

export const accordionChevronIconVariants = {
  visible: {
    opacity: 1,
    transition: { ...commonTransition, delay: 0.3 },
  },
  hidden: { opacity: 0, transition: { ...commonTransition, duration: 0.1, delay: 0.2 } },
};

export const openNavVariants = {
  visible: {
    opacity: 1,
    transition: { ...commonTransition, duration: 0.1, delay: 0 },
  },
  hidden: { opacity: 0, transition: { ...commonTransition, duration: 0.1, delay: 0.6 } },
};

export const closedNavIconVariants = {
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.3, delay: 0.2, ease: 'linear' },
  },
  hidden: { opacity: 0, scale: 1, transition: { ...commonTransition, delay: 0 } },
};

export const extraNavButtonTextVariants = {
  visible: {
    x: 0,
    opacity: 1,
    transition: { ...commonTransition, delay: 0.1 },
  },
  hidden: { x: -4, opacity: 0, transition: { ...commonTransition, delay: 0 } },
};

export const extraNavButtonIconVariants = {
  visible: {
    transition: { ...commonTransition, delay: 0.1 },
  },
  hidden: { transition: { ...commonTransition, delay: 0.2 } },
};

export const closedBadgeVariants = {
  open: { opacity: 0, transition: { duration: 0.2 } },
  closed: { opacity: 1, transition: { delay: 0.5, duration: 0.2 } },
};
